import BadgeIcon from "components/badgeIcon";
import Radio from "components/radio";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  value: boolean;
  setActiveArtist: (artist: string) => void;
  name: string;
}
const ArtistItem = ({ value, setActiveArtist, name }: IProps) => {
  return (
    <Container
      onClick={() => {
        setActiveArtist(name);
      }}
    >
      <RadioContainer>
        <Radio
          onClick={() => {
            setActiveArtist(name);
          }}
          value={value}
        />
      </RadioContainer>
      <BadgeIcon size="3.4" fontSize="lg" name={name} />
      <Typography ml="1.2" size="2xl" weight="medium">
        {name}
      </Typography>
    </Container>
  );
};

export default ArtistItem;

const Container = styled.div`
  padding: 1.9rem 1.6rem;
  display: flex;
  align-items: center;
  border-top: 0.5px solid ${Colors.grey600};
  cursor: pointer;
`;

const RadioContainer = styled.div`
  margin-right: 2.4rem;
`;
